import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ShellModule } from '@jms/module.shell';
import { environment } from './environments/environment';

// import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

//platformBrowserDynamic().bootstrapModule(ShellModule).catch(err => console.error(err));


Office.initialize = () => {
  platformBrowserDynamic()
    .bootstrapModule(ShellModule)
    .catch(err => console.error(err));
};


